import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { PartnerComponent } from './partner/partner.component';
import { SystemConfigurationComponent } from './system-configuration/components/system-configuration.component';
import { PartnerConfigurationComponent } from './partner-specific-configuration/components/partner-configuration.component';
import { InternalUsersComponent } from './internal-users/components/internal-users/internal-users.component';
import { TopconConfigurationComponent } from './topcon-configuration/components/topcon-configuration/topcon-configuration.component';

const routes: Routes = [
    {
        path: 'system-configuration',
        component: SystemConfigurationComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'partner',
        component: PartnerComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'partner-configuration',
        component: PartnerConfigurationComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'topcon-configuration',
        component: TopconConfigurationComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'internal-users',
        component: InternalUsersComponent,
        canActivate: [MsalGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdminFunctionsRoutingModule {

}
